import React, {useState, useRef, useEffect} from "react";
import { Row, Col, Button, Card, Container, Badge } from "react-bootstrap";
import defaultImage from "../assets/empty-review-photo.jpg";

const FileUpload = ({ onFileUpload }) => {
    const [previewImage, setPreviewImage] = useState(defaultImage);
    const [uploadOk, setUploadOk] = useState("");

    const fileInputRef = useRef(null);

    const [blinkOpacity, setBlinkOpacity] = useState(1);
    const blinkIntervalRef = useRef(null);

    useEffect(() => {
        if (!uploadOk || uploadOk === "NO") {
            // Запускаем мигание для "Waiting for Upload" и "Duplicate Image Detected!"
            blinkIntervalRef.current = setInterval(() => {
                setBlinkOpacity((prevOpacity) => (prevOpacity === 1 ? 0.5 : 1));
            }, 500);
        } else {
            // Останавливаем мигание при успешной загрузке
            clearInterval(blinkIntervalRef.current);
            setBlinkOpacity(1);
        }

        return () => clearInterval(blinkIntervalRef.current);
    }, [uploadOk]);


    // Handle file selection
    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setPreviewImage(URL.createObjectURL(selectedFile));
            await handleUpload(selectedFile);
        }
    };

    // Open file selection window
    const handleChooseFile = () => {
        fileInputRef.current.click();
    };

    // Upload file to server
    const handleUpload = async (file) => {
        if (!file) return;

        const formData = new FormData();
        formData.append("photos", file);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}api/assignment/temp`, {
                method: "POST",
                body: formData,
            });

            const data = await response.json();
            if (response.ok) {
                const fileName = data.uploadedFiles?.[0] || "Unknown";
                const hash = data.fileHashes?.[0] || "Not received";

                setUploadOk("OK");
                onFileUpload({ fileName, hash });
            } else {
                setUploadOk("NO");
            }
        } catch (error) {
            setUploadOk("NO");
        }
    };

    return (
        <div className="d-flex flex-column align-items-center gap-3 mt-3 position-relative w-100" style={{ maxWidth: '500px', margin: '0 auto' }}>
            {/* ✅ Бейдж состояния */}
            <div style={{
                position: "absolute",
                top: "0px",
                right: "0px",
                display: "flex",
                alignItems: "center",
                zIndex: 1
            }}>
                {!uploadOk ? (
                    <Badge
                        bg="secondary"
                        className="px-3 py-2"
                        style={{
                            fontSize: "0.875rem",
                            fontWeight: "bold",
                            opacity: blinkOpacity,
                            transition: "opacity 0.5s ease-in-out"
                        }}
                    >
                        <i className="fa-solid fa-hourglass-half me-2 fa-spin"></i>
                        Waiting for Upload Image...
                    </Badge>
                ) : uploadOk === "OK" ? (
                    <Badge
                        bg="success"
                        className="px-3 py-2"
                        style={{
                            fontSize: "0.875rem",
                            fontWeight: "bold"
                        }}
                    >
                        <i className="fa-solid me-2 fa-check"></i>
                        Uniqueness Test Passed!
                    </Badge>
                ) : (
                    <Badge
                        bg="danger"
                        className="px-3 py-2"
                        style={{
                            fontSize: "0.875rem",
                            fontWeight: "bold",
                            opacity: blinkOpacity,
                            transition: "opacity 0.5s ease-in-out"
                        }}
                    >
                        <i className="fa-solid me-2 fa-ban"></i>
                        Duplicate Image Detected!
                    </Badge>
                )}
            </div>

            {/* ✅ Превью изображения */}
            <img
                src={previewImage}
                alt="Preview"
                className="img-fluid shadow rounded"
                style={{
                    maxHeight: "330px",
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: "6px"
                }}
            />

            {/* ✅ Скрытый input */}
            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                className="d-none"
                onChange={handleFileChange}
            />

            {/* ✅ Кнопка */}
            <Button
                variant="success"
                className="mt-2 btn-sm"
                onClick={handleChooseFile}
            >
                {uploadOk === "OK" ? "Re-Upload Image" : "Upload Image"}
            </Button>
        </div>

    );
};

export default FileUpload;
